import { render } from "./VoresTjenester.vue?vue&type=template&id=b97ff8f8"
import script from "./VoresTjenester.vue?vue&type=script&lang=js"
export * from "./VoresTjenester.vue?vue&type=script&lang=js"

import "./VoresTjenester.vue?vue&type=style&index=0&id=b97ff8f8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__